import v3Generic from './v3-generic';
var _v3Generic = v3Generic('giftwraps'),
  single = _v3Generic.single,
  getAll = _v3Generic.getAll;
export default {
  single: single,
  getAll: getAll
};